(function () {
  'use strict';
  var KEY = 'off_supply_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  }

  function has(id) {
    id = String(id);
    return read().some(function (item) { return String(item.id) === id; });
  }

  function itemFromEl(el) {
    return {
      id: el.getAttribute('data-product-id'),
      handle: el.getAttribute('data-product-handle') || '',
      title: el.getAttribute('data-product-title') || '',
      url: el.getAttribute('data-product-url') || '',
      price: el.getAttribute('data-product-price') || '',
      image: el.getAttribute('data-product-image') || ''
    };
  }

  function toggle(el) {
    var item = itemFromEl(el);
    if (!item.id) return false;
    var list = read();
    var idx = list.findIndex(function (stored) { return String(stored.id) === String(item.id); });
    var active;
    if (idx === -1) {
      list.push(item);
      active = true;
    } else {
      list.splice(idx, 1);
      active = false;
    }
    write(list);
    return active;
  }

  function count() {
    return read().length;
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var on = id && has(id);
      btn.classList.toggle('is-active', !!on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', (on ? 'Remove from wishlist' : 'Add to wishlist'));
    });
  }

  function syncBadges() {
    var n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
      badge.textContent = n;
      badge.setAttribute('data-wishlist-count', n);
      if (n > 0) {
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    });
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char]);
    });
  }

  function inr(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return '';
    return Math.round(n / 100).toLocaleString('en-IN');
  }

  function inrify(root) {
    if (!root || !document.createTreeWalker) return;
    var rupee = String.fromCharCode(8377);
    var rx = new RegExp('(?:R' + 's\\.|' + rupee + ')\\s*([0-9][0-9,]*(?:\\.[0-9]{1,2})?)', 'g');
    var skip = '[data-cart-count], [data-wishlist-count], .os-header-bag-count, .os-header-wishlist-count, .rv-cur, script, style, textarea, input, select, option';
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !rx.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        rx.lastIndex = 0;
        if (node.parentElement && node.parentElement.closest(skip)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      var frag = document.createDocumentFragment();
      var last = 0;
      text.replace(rx, function (match, amount, offset) {
        if (offset > last) frag.appendChild(document.createTextNode(text.slice(last, offset)));
        var sup = document.createElement('sup');
        sup.className = 'rv-cur';
        sup.textContent = 'INR';
        frag.appendChild(sup);
        frag.appendChild(document.createTextNode(amount.replace(/\.00$/, '')));
        last = offset + match.length;
        return match;
      });
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function setSlide(car, index) {
    var track = car.querySelector('[data-rv-track]');
    if (!track) return;
    var fill = car.querySelector('[data-rv-barfill]');
    var count = track.children.length;
    if (!count) return;
    var next = ((index % count) + count) % count;
    car._rvIndex = next;
    track.style.transform = 'translateX(' + (-next * 100) + '%)';
    if (fill) fill.style.width = (((next + 1) / count) * 100) + '%';
  }

  function initCardCarousel(car) {
    if (!car || car._rvInit) return;
    car._rvInit = true;
    var track = car.querySelector('[data-rv-track]');
    if (!track) return;
    var count = track.children.length;
    car._rvIndex = 0;
    setSlide(car, 0);
    if (count <= 1) return;

    var prev = car.querySelector('[data-rv-prev]');
    var next = car.querySelector('[data-rv-next]');
    function nav(event, dir) {
      event.preventDefault();
      event.stopPropagation();
      setSlide(car, (car._rvIndex || 0) + dir);
    }
    if (prev) prev.addEventListener('click', function (event) { nav(event, -1); });
    if (next) next.addEventListener('click', function (event) { nav(event, 1); });
    car.addEventListener('mouseleave', function () { setSlide(car, 0); });
    car.addEventListener('pointerleave', function () { setSlide(car, 0); });

    var startX = null;
    var startY = null;
    var base = 0;
    var moved = false;
    car.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      base = car._rvIndex || 0;
      moved = false;
    }, { passive: true });
    car.addEventListener('touchmove', function (event) {
      if (startX == null || !event.touches || !event.touches.length) return;
      var dx = event.touches[0].clientX - startX;
      var dy = event.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        moved = true;
        var step = Math.round(-dx / (car.getBoundingClientRect().width * 0.5));
        setSlide(car, base + step);
      }
    }, { passive: true });
    car.addEventListener('touchend', function () {
      startX = null;
      startY = null;
    }, { passive: true });
    car.addEventListener('click', function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);
  }

  function scanCards(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-rv-cardcar]').forEach(initCardCarousel);
  }

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = modal.querySelector('[data-os-modal-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function money(cents) {
    return '<sup class="rv-cur">INR</sup>' + inr(cents);
  }

  function buildQuickView(product) {
    var modal = document.getElementById('os-quickview');
    var body = modal && modal.querySelector('[data-os-quickview-body]');
    if (!modal || !body) return;
    var images = product.images || [];
    var variants = product.variants || [];
    var available = variants.filter(function (variant) { return variant.available; });
    var selected = available.length === 1 ? String(available[0].id) : '';
    body.innerHTML =
      '<div class="os-qv">' +
        '<div class="os-qv__media">' +
          images.map(function (src) {
            return '<img src="' + esc(src) + '" alt="' + esc(product.title) + '" loading="lazy">';
          }).join('') +
        '</div>' +
        '<h3>' + esc(product.title) + '</h3>' +
        '<strong>' + money(product.price) + '</strong>' +
        '<div class="os-qv__chips">' +
          variants.map(function (variant) {
            var active = String(variant.id) === selected ? ' is-active' : '';
            var disabled = variant.available ? '' : ' disabled';
            var label = variant.title === 'Default Title' ? 'Add' : variant.title;
            return '<button type="button" class="' + active + '" data-qv-variant="' + esc(variant.id) + '"' + disabled + '>' + esc(label) + '</button>';
          }).join('') +
        '</div>' +
        '<button type="button" class="os-qv__add" data-qv-add' + (selected ? '' : ' disabled') + '>' + (selected ? 'Add to bag' : 'Select a size') + '</button>' +
      '</div>';

    body.querySelectorAll('[data-qv-variant]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        selected = button.getAttribute('data-qv-variant');
        body.querySelectorAll('[data-qv-variant]').forEach(function (chip) { chip.classList.toggle('is-active', chip === button); });
        var add = body.querySelector('[data-qv-add]');
        if (add) {
          add.disabled = false;
          add.textContent = 'Add to bag';
        }
      });
    });

    var add = body.querySelector('[data-qv-add]');
    if (add) {
      add.addEventListener('click', function () {
        if (!selected || add.disabled) return;
        add.disabled = true;
        add.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(selected), quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function () {
            add.textContent = 'Added';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
            if (window.myugenCartDrawer && typeof window.myugenCartDrawer.open === 'function') {
              window.myugenCartDrawer.open(add);
            }
            setTimeout(function () { closeModal(modal); }, 650);
          })
          .catch(function () {
            add.disabled = false;
            add.textContent = 'Try again';
          });
      });
    }

    openModal(modal);
  }

  function buildBreakdown(cart) {
    var modal = document.getElementById('os-breakdown');
    var body = modal && modal.querySelector('[data-os-breakdown-body]');
    if (!modal || !body) return;
    var rows = (cart.items || []).map(function (item) {
      return '<div class="os-bd-row"><span>' + esc(item.quantity + ' x ' + item.product_title) + '</span><strong>' + money(item.final_line_price) + '</strong></div>';
    }).join('');
    rows += '<div class="os-bd-row"><span>Subtotal</span><strong>' + money(cart.items_subtotal_price) + '</strong></div>';
    if (cart.total_discount) rows += '<div class="os-bd-row"><span>Discount</span><strong>-' + money(cart.total_discount) + '</strong></div>';
    rows += '<div class="os-bd-row"><span>Shipping</span><span>Calculated at checkout</span></div>';
    rows += '<div class="os-bd-row"><span>Total</span><strong>' + money(cart.total_price) + '</strong></div>';
    body.innerHTML = rows;
    openModal(modal);
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (item) {
      var price = inr(item.price);
      return (
        '<article class="os-c-product-card myugen-collection-card os-genz-card os-wishlist-card" data-os-component="product-card" data-os-tier="tissue">' +
          '<a href="' + esc(item.url) + '" class="myugen-collection-card__imglink os-genz-card__imglink">' +
            '<div class="myugen-collection-card__media os-genz-card__media" style="aspect-ratio: 2 / 3 !important; width: 100% !important; height: auto !important; min-height: 0 !important; max-height: none !important; padding: 0 !important; overflow: hidden !important; background: #fff !important; background-color: #fff !important; border-radius: 16px 16px 0 0 !important;">' +
              (item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy" style="display: block !important; width: 100% !important; max-width: 100% !important; height: 100% !important; max-height: 100% !important; object-fit: contain !important; object-position: center !important; background: transparent !important; filter: none !important; transform: none !important;">' : '') +
            '</div>' +
          '</a>' +
          '<a href="' + esc(item.url) + '" class="myugen-collection-card__info os-genz-card__info">' +
            '<span class="myugen-collection-card__type os-genz-card__type">Off Supply</span>' +
            '<div><h2 class="myugen-collection-card__title os-genz-card__title">' + esc(item.title) + '</h2></div>' +
            (price ? '<span class="myugen-collection-card__price os-genz-card__price"><sup class="rv-cur">INR</sup>' + price + '</span>' : '') +
          '</a>' +
          '<button type="button" class="os-c-wishlist-button os-wishlist os-wishlist--icon is-active" data-os-component="wishlist-button" data-os-tier="cell" data-wishlist-toggle aria-pressed="true" aria-label="Remove from wishlist"' +
            ' data-product-id="' + esc(item.id) + '" data-product-handle="' + esc(item.handle) + '" data-product-title="' + esc(item.title) + '"' +
            ' data-product-url="' + esc(item.url) + '" data-product-price="' + esc(item.price) + '" data-product-image="' + esc(item.image) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-9.3C.5 8.5 2 5 5.2 5 7 5 8.4 6 12 9c3.6-3 5-4 6.8-4C22 5 23.5 8.5 22 11.7 19.5 16.4 12 21 12 21z"/></svg>' +
          '</button>' +
        '</article>'
      );
    }).join('');
  }

  function syncAll() {
    syncButtons();
    syncBadges();
    renderGrid();
    scanCards(document);
    inrify(document.body);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(btn);
  });

  document.addEventListener('click', function (event) {
    var quick = event.target.closest && event.target.closest('[data-quickview-handle]');
    if (quick) {
      event.preventDefault();
      event.stopPropagation();
      var handle = quick.getAttribute('data-quickview-handle');
      if (!handle) return;
      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Product load failed');
          return response.json();
        })
        .then(buildQuickView)
        .catch(function () {});
      return;
    }

    var breakdown = event.target.closest && event.target.closest('[data-breakdown-open]');
    if (breakdown) {
      event.preventDefault();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart load failed');
          return response.json();
        })
        .then(buildBreakdown)
        .catch(function () {});
      return;
    }

    var close = event.target.closest && event.target.closest('[data-os-modal-close]');
    if (close) {
      event.preventDefault();
      closeModal(close.closest('.os-modal'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.os-modal:not([hidden])').forEach(closeModal);
  });

  document.addEventListener('wishlist:change', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  if (document.readyState !== 'loading') syncAll();

  if (!document.documentElement.dataset.osSharedObserverBound) {
    document.documentElement.dataset.osSharedObserverBound = 'true';
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes && Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-rv-cardcar]')) initCardCarousel(node);
          scanCards(node);
          inrify(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.OffSupplyWishlist = {
    read: read,
    has: has,
    toggle: toggle,
    count: count,
    sync: syncAll
  };
  window.OffSupplyInrify = inrify;
  window.OffSupplyScanCards = scanCards;
})();
